import BedroomIcon from "../../data/Icons/leon-inmobiliaria-icons-schlafzimmer.svg";
import BathroomIcon from "../../data/Icons/leon-inmobiliaria-icons-badezimmer.svg";
import {useTranslation} from "next-i18next";
import {ObjectInterfaceWithCity} from "../../interfaces/ObjectInterface";
import {useRouter} from "next/router";
import LastMinuteLabel from "../LastMinuteLabel";

type Furnishing = {
	persons: number;
	bedrooms: number;
	bathrooms: number;
};

interface VerkaufDetailedTitleProps {
	objectId: string;
	title: string;
	furnishing: Furnishing;
	object?: ObjectInterfaceWithCity;
	tln: string;
}

function VerkaufDetailedTitle({
	                              objectId,
	                              title,
	                              furnishing,
	                              object,
								  tln
                              }: VerkaufDetailedTitleProps) {
	const {t} = useTranslation();

	const router = useRouter();
	return (
		<div className="flex flex-col items-center md:items-start md:pl-[70px] md:pr-12 md:max-w-6xl">
			<h5 className="py-2 sm:py-4 sm:whitespace-nowrap">
				<div className="mt-2">
					<div className="text-[#a3a3a3] text-[10px] sm:text-[12px] leading-[1.2] break-all">{tln && `${tln}`}</div>
					<div className="text-[#3c3c3b] font-semibold text-[12px] sm:text-[14px] leading-[1.2] break-all">{t("components.immoCard.objectId")}: {objectId}</div>
				</div>
			</h5>
			<LastMinuteLabel object={object} hidePrice/>
			<h1 className="text-center md:text-start text-[32px] lg:text-[40px] leading-normal font-light">{title}</h1>
			<div className="flex flex-row items-center md:justify-start md:gap-x-16 justify-evenly w-full my-12">
				<div className="flex flex-col items-center space-y-2 md:flex-row md:space-x-3 whitespace-nowrap">
					<BedroomIcon className="[&>*]:!fill-black w-8"/>
					<p>
						{furnishing.bedrooms +
							" " +
							t("components.vermietungDetailedTitle.bedrooms")}
					</p>
				</div>
				<div className="flex flex-col items-center space-y-2 md:flex-row md:space-x-3 whitespace-nowrap">
					<BathroomIcon className="[&>*]:!fill-black w-8"/>
					<p>
						{furnishing.bathrooms +
							" " +
							t("components.vermietungDetailedTitle.bathrooms")}
					</p>
				</div>
			</div>
		</div>
	);
}

export default VerkaufDetailedTitle;
